export default __webpack_public_path__ + "static/media/5osiea.740ddef5.webp";